var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CpslButton, CpslIcon, CpslQrCode, CpslSpinner, CpslText } from '@usecapsule/react-components';
import { CenteredText, InnerStepContainer, QRContainer, StepContainer } from '../common.js';
import { useEffect, useMemo } from 'react';
import { useModalStore } from '../../stores/index.js';
import styled from 'styled-components';
import { useExternalWallets } from '../../providers/ExternalWalletContext.js';
import { useCopyToClipboard } from '@usecapsule/react-common';
import { ModalStep } from '../../utils/steps.js';
import { routeMobileExternalWallet } from '../../utils/routeMobileExternalWallet.js';
import { NETWORK_NOT_SUPPORTED_ERROR } from '../../constants/constants.js';
import { WalletType } from '@usecapsule/web-sdk';
export const ChainSwitch = () => {
    const [isCopied, copy] = useCopyToClipboard();
    const externalWalletError = useModalStore(state => state.externalWalletError);
    const setStep = useModalStore(state => state.setStep);
    const setStepDirection = useModalStore(state => state.setStepDirection);
    const { switchChain, wallet, qrUri, chainIdSwitchingTo, walletDisplayHelpers } = useExternalWallets();
    useEffect(() => {
        if ((wallet === null || wallet === void 0 ? void 0 : wallet.type) === WalletType.COSMOS) {
            routeMobileExternalWallet(qrUri);
        }
    }, [qrUri, wallet]);
    useEffect(() => {
        if (!wallet) {
            setStepDirection(-1);
            setStep(ModalStep.ACCOUNT_MAIN);
        }
    }, [wallet]);
    const handleTryAgainClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (chainIdSwitchingTo) {
            yield switchChain(chainIdSwitchingTo);
        }
    });
    const handleCopy = () => {
        copy(qrUri);
    };
    const Content = useMemo(() => {
        if (!wallet) {
            return null;
        }
        const { isCosmosMobileWallet } = walletDisplayHelpers;
        if (isCosmosMobileWallet) {
            return (_jsx(_Fragment, { children: _jsxs(InnerStepContainer, { children: [_jsx(CpslText, { weight: "semiBold", children: "Scan with your mobile device to switch networks" }), _jsx(QRContainer, { children: !qrUri ? _jsx(CpslSpinner, { size: 100 }) : _jsx(CpslQrCode, { url: qrUri, imageSrc: wallet.iconUrl }) }), _jsxs(CpslButton, { size: "small", variant: "ghost", onClick: handleCopy, children: [_jsx(CpslIcon, { slot: "start", icon: isCopied ? 'check' : 'copy' }), isCopied ? 'Copied' : 'Copy Link'] })] }) }));
        }
        return (_jsxs(InnerStepContainer, { children: [!(externalWalletError === null || externalWalletError === void 0 ? void 0 : externalWalletError.length) ? (_jsx(CenteredText, { color: "contrast", weight: "semiBold", children: `Confirm the request to change networks in your ${wallet.name} wallet.` })) : (_jsxs(_Fragment, { children: [_jsxs(ErrorContainer, { children: [_jsx(ErrorIcon, { icon: "alertCircle" }), _jsx(CenteredText, { weight: "semiBold", color: "error", children: externalWalletError[0] })] }), externalWalletError[1] && (_jsx(CenteredText, { color: "secondary", weight: "medium", children: externalWalletError[1] }))] })), (externalWalletError === null || externalWalletError === void 0 ? void 0 : externalWalletError[0].toLowerCase()) !== NETWORK_NOT_SUPPORTED_ERROR && (_jsxs(CpslButton, { variant: "secondary", onClick: handleTryAgainClick, children: [_jsx(CpslIcon, { slot: "start", icon: "refresh" }), "Try Again"] }))] }));
    }, [wallet, walletDisplayHelpers, externalWalletError, qrUri]);
    if (!wallet) {
        return null;
    }
    return _jsx(Container, { children: Content });
};
const Container = styled(StepContainer) `
  flex: 1;
  justify-content: space-between;
`;
const ErrorContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
const ErrorIcon = styled(CpslIcon) `
  --height: 16px;
  --width: 16px;
  --icon-color: var(--cpsl-color-text-error);
`;
